import type { Person } from '~/types'

export const resolveEmployeeFullName = (employee: Person) => {
  return `${employee.title_before ? employee.title_before + ' ' : ''} ${employee.first_name} ${employee.last_name}${employee.title_after ? ',' : ''} ${employee.title_after ? ' ' + employee.title_after : ''}`
}
